import React, { useEffect, useState } from 'react'
import { useStyles } from './TemplateCardTextProperties.styles'
import { SelectChangeEvent, Typography } from '@mui/material'
import { ColorSelectorV2, SelectV2 } from '@labrav/react-components'
import { useFormikContext } from 'formik'
import clsx from 'clsx'
import {
  extractColorV2,
  hexadecimalColor,
} from '../../../../common/utils/productCreationUtil'
import { convertRGBAAlpha } from '../../../../common/utils/convertRGBAAlpha'
import { calculateMinMaxResult } from '../../../AddEditProductFormComponents/FlyOutProductBranding/FlyOutProductBranding'
import { useStyles as commonStyles } from '../../FlyOutStorefront.styles'
import { TemplateInCreation } from '../../../../modules/storefront/templateCreation/reducer'
import {
  fontSizes,
  fontWeights,
} from '../../../../utils/templateCreationConstants'
import { hexToRgb, rgbToHex } from '../../../../utils/colorsConvertor'
import { ListingCardInCreation } from '../../../../modules/storefront/listingCardCreation/reducer'

export const TemplateCardTextProperties: React.FC = () => {
  const { classes } = useStyles()
  const { classes: commonClasses } = commonStyles()
  const { values, errors, touched, setFieldValue, handleBlur, handleChange } =
    useFormikContext<ListingCardInCreation>()
  const { listingCardData } = values
  const [colorType, setColorType] = useState<string>(
    listingCardData?.template?.data?.productTitle?.customization.color
      ? listingCardData?.template?.data?.productTitle?.customization.color?.includes(
          '#'
        )
        ? 'HEX'
        : 'RGB'
      : 'HEX'
  )
  const [headerColor, setHeaderColor] = useState<string[]>(() => {
    const colorString =
      listingCardData?.template?.data?.productTitle?.customization.color || ''
    return extractColorV2(colorType, colorString)
  })
  useEffect(() => {
    const colorString =
      listingCardData?.template?.data?.productTitle?.customization.color || ''
    setHeaderColor(extractColorV2(colorType, colorString))
  }, [listingCardData?.template?.data?.productTitle?.customization.color])

  const handleTypeChange = async (event: SelectChangeEvent) => {
    const typeValue = event.target.value as string
    const resetValue =
      typeValue === 'RGB'
        ? hexToRgb(headerColor[4]).toString()
        : rgbToHex(
            parseInt(headerColor[0]),
            parseInt(headerColor[1]),
            parseInt(headerColor[2])
          )
    setColorType(typeValue)
    await setFieldValue(
      'listingCardData.template.data.productTitle.customization.color',
      resetValue
    )
  }

  const handleColorChange = async (index: number, event: SelectChangeEvent) => {
    const updatedColorValues = calculateMinMaxResult(
      index,
      [...headerColor],
      event.target.value as string
    )
    if (colorType === 'RGB') {
      const color = `rgba(${updatedColorValues[0]}, ${updatedColorValues[1]}, ${updatedColorValues[2]}, 100)`
      await setFieldValue(
        'listingCardData.template.data.productTitle.customization.color',
        color
      )
    } else {
      const color = hexadecimalColor(`${updatedColorValues[4]}`, 100)
      await setFieldValue(
        'listingCardData.template.data.productTitle.customization.color',
        color
      )
    }
  }

  return (
    <div
      className={clsx(
        classes.sectionWrapper,
        classes.sectionHeaderWrapper,
        classes.root,
        classes.content
      )}
      data-testid="card-text-properties-component"
    >
      <div className={classes.textContentWrapper}>
        <Typography
          // className={commonClasses.cardTextHeader}
          className={classes.textHeading}
          data-testid="card-header-text"
        >
          Card header text properties
        </Typography>
      </div>
      <div className={classes.rowContainer}>
        <div className={classes.colorSelectorWidth}>
          <ColorSelectorV2
            data-testid="card-header-text-color-selector"
            selectedField={colorType}
            placeholder={'#FFFFFF'}
            onBlur={handleBlur}
            onChange={handleTypeChange}
            keyName={
              'listingCardData.template.data.productTitle.customization.color'
            }
            colorValues={headerColor}
            handleColorChange={handleColorChange}
            color={convertRGBAAlpha(
              listingCardData?.template?.data?.productTitle?.customization
                .color || '',
              false
            )}
            isError={
              !!(
                (touched as any).listingCardData?.template?.data?.productTitle
                  ?.customization.color &&
                (errors as any).listingCardData?.template?.data?.productTitle
                  ?.customization.color
              )
            }
            errorText={
              !!(touched as any).listingCardData?.template?.data?.productTitle
                ?.customization.color &&
              ((errors as any).listingCardData?.template?.data?.productTitle
                ?.customization.color ||
                '')
            }
            secondaryVariant={true}
          />
        </div>
        <div>
          <SelectV2
            data-testid="card-header-text-font-size-selector"
            minWidth="119px"
            field={{
              title: 'Font Size',
              placeHolder: 'Font Size',
              id: 'listingCardData.template.data.productTitle.customization.fontSize',
              isRequired: false,
              humanReadableKey: 'fontSize',
              isReadOnly: false,
              isCustom: false,
              defaultValue: '12px',
              dataType: 'string',
              options: fontSizes,
            }}
            value={
              listingCardData?.template?.data?.productTitle?.customization
                .fontSize || '12px'
            }
            key={
              'listingCardData.template.data.productTitle.customization.fontSize'
            }
            onChange={handleChange}
            onBlur={handleBlur}
            isError={false}
            errorText={''}
            isRequired={false}
          />
        </div>
        <div>
          <SelectV2
            data-testid="card-header-text-font-weight-selector"
            minWidth="119px"
            field={{
              title: 'Font Weight',
              placeHolder: 'Font Weight',
              id: 'listingCardData.template.data.productTitle.customization.fontWeight',
              isRequired: false,
              humanReadableKey: 'fontWeight',
              isReadOnly: false,
              isCustom: false,
              defaultValue: '400',
              dataType: 'string',
              options: fontWeights,
            }}
            value={
              listingCardData?.template?.data?.productTitle?.customization
                .fontWeight || '400'
            }
            key={
              'listingCardData.template.data.productTitle.customization.fontWeight'
            }
            onChange={handleChange}
            onBlur={handleBlur}
            isError={false}
            errorText={''}
            isRequired={false}
          />
        </div>
      </div>
    </div>
  )
}
